import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, apiError, saveGrant } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { SectionHeading, GoldButton } from "@/components/Brand";

export default function InvitePage() {
  const { token } = useParams();
  const { t, path } = useI18n();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api
      .post(`/invites/${token}/redeem`)
      .then(({ data }) => {
        saveGrant(data.slug, data.access_token);
        navigate(path("events", data.slug), { replace: true });
      })
      .catch((err) => setError(apiError(err.response?.data?.detail)));
  }, [token, navigate, path]);

  return (
    <div className="mx-auto max-w-xl px-4 py-20 sm:px-8" data-testid="invite-page">
      {error ? (
        <>
          <SectionHeading label="HR Creations" title={t("invite.invalid")} sub={error} />
          <GoldButton as="a" href={path("clientGalleries")} className="mt-8" data-testid="invite-fallback-link">
            {t("btn.clientGalleries")}
          </GoldButton>
        </>
      ) : (
        <p className="text-sm text-[#5A5752]" data-testid="invite-loading">
          {t("invite.opening")}
        </p>
      )}
    </div>
  );
}
